import type { SVGProps } from 'react';
const SvgIconOrg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 8.5a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zm-2.1 1.51a.5.5 0 0 0-.4.49v2l.01.1c.04.196.194.35.39.39L3 13h2l.1-.01a.5.5 0 0 0 .39-.39l.01-.1v-2a.5.5 0 0 0-.4-.49L5 10H3zM13 8.5a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zM11 10l-.1.01a.5.5 0 0 0-.4.49v2l.01.1c.04.196.194.35.39.39l.1.01h2l.1-.01a.5.5 0 0 0 .39-.39l.01-.1v-2a.5.5 0 0 0-.4-.49L13 10zM9 1.5a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zM6.9 3.01a.5.5 0 0 0-.4.49v2l.01.1c.04.196.194.35.39.39L7 6h2l.1-.01a.5.5 0 0 0 .39-.39l.01-.1v-2a.5.5 0 0 0-.4-.49L9 3H7z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconOrg;
